// extracted by mini-css-extract-plugin
module.exports = {"root":"root___1UvXX","form":"form___2LbWv","title":"title___3N9wd","subTitle":"subTitle___3OEdE","loading":"loading___1M7Di"};